import { Col, Row, Space, Button } from "antd";
import { Form, Formik } from "formik";

import { DatePicker, Input, Select } from "components/form";
import useStatusFlagOption from "components/elements/Select/StatusDropdown";
import styles from "../styles/WorkscheduleFilter.module.css";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

const WorkscheduleFilterModal = ({
    initialValues = {},
    dataFlag = " ",
    onSubmit = () => { },
    departmentOptions = [],
    positionOptions = [],
    employeeTypeOptions = [],
    attendanceSettingShift = [],
    setSearchName = () => { },
    setSearchNo = () => { },
    setSearchDepartment = () => { },
    setSearchPosition = () => { },
    setDataSourceModal = () => { },
}) => {
    function onResetFilter() {
        setSearchName("");
        setSearchNo("");
        setSearchDepartment();
        setSearchPosition();
    }
    console.log("🚀 ~ departmentOptions:", departmentOptions)
    const { t } = useTranslation();
    const { modifiedStatus = [] } = useStatusFlagOption();
    console.log('menu', dataFlag);
    function formatDate(dateString, pattern = "DD-MM-YYYY") {
        // console.log("dateString", dateString);
        if (!dateString) return;
        const date = dayjs(dateString, pattern);
        return date.format("DD-MM-YYYY");
    }
    const shiftTypeOptions = [
        {
            value: "SWAP",
            label: t('changeshift.swap')
        },
        {
            value: "CHANGESHIFT",
            label: t('changeshift.label.changeshift')
        }
    ]
    return (
        <Formik
            initialValues={initialValues}
            onSubmit={(values) => {
                console.log("🚀 ~ values:", values)
                onSubmit({
                    ...values,
                    page: 0,
                    size: 10
                }, null, setDataSourceModal);
            }}
        >
            {({ resetForm, values = {}, setFieldValue = () => { }, setTouched = () => { }, submitForm }) => {
                return (
                    <Form>

                        <Row gutter={[24, 16]} className={styles.filter} >
                            <Col span={12}>
                                <Input
                                    name="employeeNo"
                                    label={t('employee.label.employee_no')}
                                    placeholder={t('common.please_fill')}
                                    size="large"
                                    onChange={setSearchNo}
                                />
                            </Col>
                            <Col span={12}>
                                <Input
                                    name="employeeName"
                                    label={t('employee.label.name')}
                                    placeholder={t('common.please_fill')}
                                    size="large"
                                    onChange={setSearchName}
                                />
                            </Col>
                            {/* <Col span={8}>
                                <Select
                                    required={true}
                                    name="employeeTypeId"
                                    label={t('employment-information.label.employee-type')}
                                    placeholder={t('employment-information.label.report-to')}
                                    size="large"
                                    options={employeeTypeOptions} />
                            </Col> */}
                            {/* <Col span={12}>
                                <Select
                                    name="shift"
                                    label={t('changeshift.label.newshift')}
                                    placeholder={t('changeshift.label.newshift')}
                                    size="large"
                                    options={attendanceSettingShift}
                                />
                            </Col> */}
                            {/* <Col span={8}>
                                <Select
                                    name="statusFlag"
                                    label={t('translation.status')}
                                    placeholder={t('translation.status')}
                                    size="large"
                                    options={modifiedStatus}
                                />
                            </Col> */}
                        </Row>
                        <Row gutter={[24, 16]} className={styles.filter} >
                            <Col span={12}>
                                <Select
                                    // required={true}
                                    name="departmentIds"
                                    label={t('employee.label.department')}
                                    placeholder={t('common.pleaseSelect')}
                                    size="large"
                                    mode="multiple"
                                    onSearch={setSearchDepartment}
                                    options={departmentOptions} />
                            </Col>
                            <Col span={12}>
                                <Select
                                    // required={true}
                                    name="positionIds"
                                    label={t('employee.label.position')}
                                    placeholder={t('common.pleaseSelect')}
                                    size="large"
                                    mode="multiple"
                                    onSearch={setSearchPosition}
                                    options={positionOptions} />
                            </Col>
                            {/* <Col span={8}>
                                <Select
                                    required={true}
                                    name="employeeTypeId"
                                    label={t('employment-information.label.employee-type')}
                                    placeholder={t('employment-information.label.report-to')}
                                    size="large"
                                    options={employeeTypeOptions} />
                            </Col> */}
                            {/* <Col span={12}>
                                <Select
                                    name="shift"
                                    label={t('changeshift.label.newshift')}
                                    placeholder={t('changeshift.label.newshift')}
                                    size="large"
                                    options={attendanceSettingShift}
                                />
                            </Col> */}
                            {/* <Col span={8}>
                                <Select
                                    name="statusFlag"
                                    label={t('translation.status')}
                                    placeholder={t('translation.status')}
                                    size="large"
                                    options={modifiedStatus}
                                />
                            </Col> */}
                        </Row>

                        <Row justify="end">
                            <Space size={24} className={styles.filter}>
                                <Button type="default" onClick={() => {
                                    resetForm()
                                    onResetFilter()
                                }} style={{ borderRadius: "8px" }}>
                                    {t('payroll.reset').toUpperCase()}
                                </Button>
                                <Button type="primary" onClick={() => {
                                    console.log("click");
                                    submitForm()
                                }} style={{ backgroundColor: "var(--button-color)", borderRadius: "8px" }}>
                                    {t("creatTamplete.Search").toUpperCase()}
                                </Button>
                            </Space>
                        </Row>
                    </Form>
                );
            }}

        </Formik>
    )
};

export default WorkscheduleFilterModal;
